import API from '@/api/base'
import axios from 'axios'
import store from '@state/store'
import moment from 'moment'
import cookieService from 'vue-cookies'

function getUserInfo(userId) {
  return new Promise((resolve, reject) => {
    API.find('customer', userId.slice(1, -1))
      .then((response) => {
        store.dispatch('auth/saveUser', response.data)
        resolve()
      })
      .catch(() => {
        // Something has gone wrong, clear the saved user info
        store.dispatch('auth/logOut')
        reject(new Error('logout'))
      })
  })
}

export function getSavedState(key) {
  // return JSON.parse(window.localStorage.getItem(key))
  const storage = cookieService.get(key)
  if (storage != null) {
    if (Object.prototype.hasOwnProperty.call(storage, 'expiry')) {
      const diff = moment(storage.expiry).diff(moment(), 'days')
      // if less than a week old, return user id
      if (diff < 7) {
        if (key === 'socC2' && storage.payload !== 'null') {
          getUserInfo(storage.payload)
            .then(() => {
              return storage.payload
            })
            .catch(() => {
              return null
            })
        } else {
          return storage.payload === 'null' ? null : storage.payload
        }
      }
      cookieService.remove(key)
    }
  }
  return null
}

export function saveState(key, state) {
  // window.localStorage.setItem(key, JSON.stringify(state))
  const bundle = {
    payload: JSON.stringify(state),
    expiry: moment().add('7', 'days'),
  }
  // saveState('auth.currentUserId', newValue)
  cookieService.set(key, JSON.stringify(bundle), '7d')
}

export function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentUserId
    ? state.currentUserId.token
    : ''
}
